import { type Component, For, Show } from "solid-js";

export interface ErrorAction {
  label: string;
  onClick: () => void;
  subtle?: boolean;
}

export interface ErrorBlockProps {
  title: string;
  meta?: string;
  detail?: string;
  actions?: ErrorAction[];
}

const ErrorBlock: Component<ErrorBlockProps> = (props) => {
  return (
    <div class="error-block" role="alert">
      <div class="error-head">
        <span class="error-title">{props.title}</span>
        <Show when={props.meta}>
          <span class="error-meta">{props.meta}</span>
        </Show>
      </div>
      <Show when={props.detail}>
        <div class="error-detail">{props.detail}</div>
      </Show>
      <Show when={props.actions && props.actions.length > 0}>
        <div class="error-actions">
          <For each={props.actions}>
            {(action) => (
              <button
                type="button"
                class={`error-action${action.subtle ? " subtle" : ""}`}
                onClick={action.onClick}
              >
                {action.label}
              </button>
            )}
          </For>
        </div>
      </Show>
    </div>
  );
};

export default ErrorBlock;
